import { store } from './redux/store'
import { Provider } from 'react-redux'
import { toast, ToastContainer } from 'react-toastify'
import { RouterProvider } from 'react-router-dom'
import router from './router'
import { useEffect } from 'react'
import config from './config/config'
import { logger } from './utils'

const App = (): React.JSX.Element => {
  useEffect(() => {
    try {
      // Validate that all environment variables are present.  If not,
      // handle error.
      config.loadEnvironmentVariables()
    } catch (error) {
      const err = error as Error
      logger.error(err)
      toast.error(err.message, { position: toast.POSITION.TOP_CENTER })
    }
  }, [config])

  return (
    <Provider store={store}>
      <ToastContainer autoClose={false} limit={4} />
      <RouterProvider router={router} />
    </Provider>
  )
}

export default App
